// extracted by mini-css-extract-plugin
export default {"background":"GridPage_background__Twksh","active":"GridPage_active__+17tE"};